import { render, staticRenderFns } from "./CustomerBillList.vue?vue&type=template&id=3a4e87a6"
import script from "./CustomerBillList.vue?vue&type=script&lang=js"
export * from "./CustomerBillList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports